import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import VeilleSection from '../components/news/VeilleSection';
import './News.css';

const News = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <SEO
        page="actualites"
        breadcrumb={[{ name: 'Accueil', path: '/' }, { name: 'Actualités', path: '/actualites' }]}
      />
      <div className="service-page" data-testid="news-page">
        <PageHero
          symbol="gradient"
          title="Actualités"
          subtitle="Alertes de sécurité, actualités RGPD et infogérance : les sources officielles CERT-FR et CNIL, les éditeurs et la presse spécialisée, filtrés et résumés par nos experts."
          testId="news-hero"
        />

        <VeilleSection />
      </div>
    </>
  );
};

export default News;
